import { render, staticRenderFns } from "./JMATypeLavel.vue?vue&type=template&id=fdd2480a"
import script from "./JMATypeLavel.vue?vue&type=script&lang=js"
export * from "./JMATypeLavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports